<template>
    <prime-card class="mx-6 mb-6 max-w-screen-xl lg:mx-12 lg:my-6 xl:mx-auto">
        <template #content>
            <span class="text-xl text-gray-700">{{
                t('checkoutSuccess.thanks')
            }}</span>
            <div class="my-2 text-4xl font-bold text-gray-900">
                {{ t('tickets.successfulSubmission') }}
            </div>
            <p class="mb-4 mt-0 p-0 text-xl text-gray-700">
                {{ t('tickets.getBackSoon') }}
            </p>
            <div
                :style="{
                    height: '3px',
                    background:
                        'linear-gradient(90deg, rgb(var(--color-primary-600)) 0%, rgba(33, 150, 243, 0) 50%)'
                }"
            ></div>

            <div
                class="flex flex-col py-5 sm:flex-row sm:items-center sm:justify-between"
            >
                <div class="mb-3 sm:mb-0">
                    <span class="mr-2 text-xl font-medium text-gray-900">{{
                        t('tickets.ticketReference')
                    }}</span>
                    <span class="text-xl font-medium text-primary-500"
                        >#{{ ticketData.reference }}</span
                    >
                </div>
            </div>

            <div class="mt-8 text-2xl">
                <label class="font-semibold">{{ t('subject') }}</label>
                <p>
                    {{ ticketData.subject }}
                </p>
            </div>

            <div class="mt-8 text-2xl">
                <label class="font-semibold">{{ t('message') }}</label>
                <div v-html="ticketData.comments.edges[0].node.bodyMarkup" />
            </div>
        </template>
    </prime-card>
</template>

<script setup lang="ts">
import { useHead } from 'unhead'
import PrimeCard from 'primevue/card'
import type { FragmentType } from '~/resources/graphql'
import { getFragmentData } from '~/resources/graphql'
import { TicketConfirmationTicketFragment } from '~/components/Tickets/TicketConfirmation.vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
    ticket: FragmentType<typeof TicketConfirmationTicketFragment>
}>()

const ticketData = getFragmentData(
    TicketConfirmationTicketFragment,
    props.ticket
)
const { t } = useI18n({ useScope: 'global' })

useHead({
    title: t('contactUs')
})
</script>
